import { IBarcode } from '@app/models/barcode.interface';
import { IProduct } from '@app/models/product.interface';
import { createAction, props } from '@ngrx/store';

export const loadProducts = createAction(
  '[Products] Load Products',
  props<any>()
);

export const loadProductsSuccess = createAction(
  '[Products] Load Products Success',
  props<{ products: IProduct[], total: number }>()
);

export const loadProductsFailure = createAction(
  '[Products] Load Products Failure',
  props<{ error: any }>()
);

export const filterByCategory = createAction(
  '[Products] Filter Products By Category',
  props<{ prdCatID: number, active: string, direction: string }>()
);

export const filterByCategorySuccess = createAction(
  '[Products] Filter Products By Category Success',
  props<any>()
);

export const filterByCategoryFailure = createAction(
  '[Products] Filter Products By Category Failure',
  props<{ error: any }>()
);

export const filterToggleStorage = createAction(
  '[Products] Filter Products Toggle Storage',
  props<{ prdStorage: number, active: string, direction: string }>()
);

export const filterToggleStorageSuccess = createAction(
  '[Products] Filter Products Toggle Storage Success',
  props<any>()
);

export const filterToggleStorageFailure = createAction(
  '[Products] Filter Products Toggle Storage Failure',
  props<{ error: any }>()
);

export const filterByStorages = createAction(
  '[Products] Filter Products By Storages',
  props<{ prdStoragesIDs: any, active: string, direction: string }>()
);

export const filterByStoragesSuccess = createAction(
  '[Products] Filter Products By Storages Success',
  props<any>()
);

export const filterByStoragesFailure = createAction(
  '[Products] Filter Products By Storages Failure',
  props<{ error: any }>()
);


export const saveProduct = createAction(
  '[Products] Save Product',
  props<{ form: any }>()
);

export const saveProductSuccess = createAction(
  '[Products] Save Product Success',
  props<any>()
);

export const saveProductFailure = createAction(
  '[Products] Save Product Failure',
  props<{ error: any }>()
);

export const updateProduct = createAction(
  '[Products] Update Product',
  props<{ form: any }>()
);

export const updateProductSuccess = createAction(
  '[Products] Update Product Success',
  props<{ product: any }>()
);

export const updateProductFailure = createAction(
  '[Products] Update Product Failure',
  props<{ error: any }>()
);

// Changes a few fields of one row in the loaded list, e.g. the cover photo
// after the gallery changes in the edit dialog, without reloading the page.
export const patchProductInList = createAction(
  '[Products] Patch Product In List',
  props<{ prdID: number, changes: any }>()
);

export const loadProduct = createAction(
  '[Products] Load Product',
  props<{ prdID: any }>()
);

export const addProductStorages = createAction(
  '[Products] Add Product Storages',
  props<{ productIDs: any,storageIDs:any, query?: string, prdStorage?: any, prdCatID?: any }>()
);

export const addProductStoragesSuccess = createAction(
  '[Products] Add Product Storages Success',
  props<any>()
);

export const addProductStoragesFailure = createAction(
  '[Products] Add Product Storages Failure',
  props<{ error: any }>()
);

export const loadProductSuccess = createAction(
  '[Products] Load Product Success',
  props<{ product: any }>()
);

export const loadProductFailure = createAction(
  '[Products] Load Product Failure',
  props<{ error: any }>()
);

export const filterByArea = createAction(
  '[Products] Filter Products By Area',
  props<{ prdAreaID: number, active: string, direction: string }>()
);

export const filterByAreaSuccess = createAction(
  '[Products] Filter Products By Area Success',
  props<any>()
);

export const filterByAreaFailure = createAction(
  '[Products] Filter Products By Area Failure',
  props<{ error: any }>()
);

export const search = createAction(
  '[Products] Search',
  props<{ query: string }>()
);

export const searchSuccess = createAction(
  '[Products] Search Success',
  props<{ products: IProduct[], total: number}>()
);

export const searchFailure = createAction(
  '[Products] Search Failure',
  props<{ error: any }>()
);

export const incrementPage = createAction(
  '[Products] Increment Pagination',
  props<{ currentPage: any }>()
);

export const resetPage = createAction(
  '[Products] Reset Pagination'
);

export const resetProducts = createAction(
  '[Products] Reset Products'
);

export const incrementPageSuccess = createAction(
  '[Products] Increment Pagination Success',
  props<{ currentPage: any }>()
);

export const decrementPage = createAction(
  '[Products] Decrement Pagination'
);

export const setBarcodeType = createAction(
  '[Products] Set Barcodes',
  props<{ data: any }>()
);

export const loadBarcodeType = createAction(
  '[Products] Load Barcodes',
  props<{ data: any }>()
);

export const setFilterType = createAction(
  '[Products] Set Filter Type',
  props<{ filterType: string, filterID: any }>()
);

export const setSelected = createAction(
  '[Products] Set Selected',
  props<{ selected: any }>()
);

export const setSort = createAction(
  '[Products] Set Sort',
  props<{ sort: string, direction: string, query: string }>()
);

export const resetProduct = createAction(
  '[Products] Reset Product'
);

export const resetFilter = createAction(
  '[Products] Reset Filter'
)

export const setDeselected = createAction(
  '[Products] Set Deselected'
);

export const deleteProducts = createAction(
  '[Products] Delete Products',
  props<any>()
);

export const deleteProductsSuccess = createAction(
  '[Products] Delete Products Success',
  props<any>()
);

export const deleteProductsFailure = createAction(
  '[Products] Delete Products Failure',
  props<{ error: any }>()
);

export const deleteProduct = createAction(
  '[Products] Delete Product',
  props<{prdID: number,query: string,prdStorage: number }>()
);

export const removeProductsFromLocation = createAction(
  '[Products] Remove Products From Location',
  props<{ selected: number[]; query: string; prdStorage: number; prdCatID?: number; reason?: string }>()
);

export const removeProductsFromLocationSuccess = createAction(
  '[Products] Remove Products From Location Success',
  props<{ query: string; prdStorage: number; prdCatID?: number }>()
);

export const removeProductsFromLocationFailure = createAction(
  '[Products] Remove Products From Location Failure',
  props<{ error: any }>()
);

export const deleteProductSuccess = createAction(
  '[Products] Delete Product Success',
  props<any>()
);

export const deleteProductFailure = createAction(
  '[Products] Delete Product Failure',
  props<{ error: any }>()
);

export const createBarcode = createAction(
  '[Products] Create Barcode',
  props<{barcodeData: string, prdID: number }>()
);

export const createBarcodeSuccess = createAction(
  '[Products] Create Barcode Success',
  props<any>()
);

export const createBarcodeFailure = createAction(
  '[Products] Create Barcode Failure',
  props<{ error: any }>()
);

export const setBarcodes = createAction(
  '[Products] Set Barcode',
  props<{barcodes: IBarcode[] }>()
);

export const setSelectedBarcode = createAction(
  '[Products] Set Selected Barcode',
  props<{ index: number }>()
)

export const deleteBarcode = createAction(
  '[Products] Delete Barcode',
  props<{barcodeID: number }>()
);

export const deleteBarcodeSuccess = createAction(
  '[Products] Delete Barcode Success',
  props<any>()
);

export const deleteBarcodeFailure = createAction(
  '[Products] Delete Barcode Failure',
  props<{ error: any }>()
);

export const exportProducts = createAction(
  '[Products] Export Products'
);

export const sortByCategory = createAction(
  '[Products] Sort By Category Products',
  props<{ active: string, direction:string, category: number }>()
);

export const sortByCategorySuccess = createAction(
  '[Products] Sort By Category Products Success',
  props<any>()
);

export const onOverride = createAction(
  '[Products] Override Products Success',
  props<any>()
);

export const sortByCategoryFailure = createAction(
  '[Products] Sort By Category Products Failure',
  props<{ error: any }>()
);

export const setIsLoading = createAction(
  '[Products] Set Is Loading',
  props<{ isLoading: boolean }>()
);

export const updateDisplayedColumns = createAction(
  '[Columns] Update Displayed Columns',
  props<{ displayedColumns: string[] }>()
);

